import React, { useEffect, useState } from 'react';
import "../src/Areas/Admin/Content/css/css.css"
import "./Areas/Admin/Content/css/admin-responsive.css"

import AdminHomePage from './AdminHomePage';
import AdminTintucPage from './AdminTintucPage';
import AdminTinTucEditPage from './AdminTinTucEditPage';
import AdminVideoEditPage from './AdminVideoEditPage';
import AdminAudioEditPage from './AdminAudioEditPage';
import AdminKinhSachEditPage from './AdminKinhSachEditPage';
import AdminThongBaoEditPage from './AdminThongBaoEditPage';
import AdminHinhAnhEditPage from './AdminHinhAnhEditPage';
import AdminGiangSuEditPage from './AdminGiangSuEditPage';
import AdminGuongSangTuHanhEditPage from './AdminGuongSangTuHanhEditPage';
import AdminAudioTheoBoEditPage from './AdminAudioTheoBoEditPage';
import AdminTrangEditPage from './AdminTrangEditPage';
import AdminNhacPhatGiaoEditPage from './AdminNhacPhatGiaoEditPage';
import AdminSachNoiEditPage from './AdminSachNoiEditPage';
import AdminSlideShowHeaderEditPage from './AdminSlideShowHeaderEditPage';
import AdminSlideShowHomeEditPage from './AdminSlideShowHomeEditPage';
import AdminPlaceholderPage from './AdminPlaceholderPage';
import AdminProfilePage from './AdminProfilePage';
import AdminPendingPage from './AdminPendingPage';
import AdminSettingPage from './AdminSettingPage';
import AdminMenuPage from './AdminMenuPage';
import AdminAccountPage from './AdminAccountPage';
import AdminAccountEditPage from './AdminAccountEditPage';
import AdminRolePage from './AdminRolePage';
import AdminRoleEditPage from './AdminRoleEditPage';
import AdminRolePermissionEditPage from './AdminRolePermissionEditPage';
import AdminFileManagerPage from './AdminFileManagerPage';
import AdminEmailPage from './AdminEmailPage';
import AdminPosttypePage from './AdminPosttypePage';
import AdminLanguagePage from './AdminLanguagePage';
import AdminAttributePage from './AdminAttributePage';
import AdminGeneralSettingPage from './AdminGeneralSettingPage';
import AdminCategoryPage from './AdminCategoryPage';
import AdminCategoryEditPage from './AdminCategoryEditPage';
import AdminNhacPhatGiaoPage from './AdminNhacPhatGiaoPage';
import AdminSachNoiPage from './AdminSachNoiPage';

function AdminPage() {
    const [open, setOpen] = useState(window.innerWidth >= 1045);
    const [openSubMenus, setOpenSubMenus] = useState({
        cms: false,
        media: false,
        tuydinh: false,
        settingmanager: false
    });
    const [activeTab, setActiveTab] = useState('0');
    const [editingRole, setEditingRole] = useState(null);
    const [currentMenu, setCurrentMenu] = useState('home');
    const [currentPostId, setCurrentPostId] = useState(null);
    const [currentCategoryType, setCurrentCategoryType] = useState(null);
    const [currentCategoryName, setCurrentCategoryName] = useState("");
    const [userName, setUserName] = useState('');
    const [userMenuOpen, setUserMenuOpen] = useState(false);

    // Phân quyền UI theo vai trò (feature 002) — server vẫn là hàng rào thật
    const role = (localStorage.getItem('role') || '').toUpperCase();
    const isAdmin = role === 'ADMIN' || role === 'ROOTADMIN';
    const isMaker = role === 'MAKER';
    const isChecker = role === 'CHECKER';

    useEffect(() => {
        const token = localStorage.getItem('token');
        if (!token) {
            window.location.href = '/login';
            return;
        }
        setUserName(localStorage.getItem('userName') || 'Admin');

        document.body.style.setProperty('background-image', 'none', 'important');
        document.body.style.setProperty('padding-top', '0px', 'important');
        document.body.style.setProperty('background-color', '#e9eaed', 'important');

        const handleResize = () => {
            if (window.innerWidth >= 1045) {
                setOpen(true);
            } else {
                setOpen(false);
            }
        };

        // Attach the event listener
        window.addEventListener('resize', handleResize);

        // Cleanup on unmount
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const toggleItemMenu = (title) => {
        setOpen(prevOpen => !prevOpen);
    };

    const toggleSubMenu = (menuId) => {
        setOpenSubMenus(prev => ({
            ...prev,
            [menuId]: !prev[menuId]
        }));
    };

    const changeCurrentPostId = (postId) => {
        setCurrentPostId(postId)
    };

    const clickChangeMenu = (temp) => {
        console.log('menu: ', temp)
        if (temp !== 'edit') {
            setCurrentPostId(null);
        }
        if (temp == 'create' || temp == 'edit') {
            if (currentMenu.startsWith('categoryList')) {
                setCurrentMenu('categoryList-' + temp);
            } else {
                setCurrentMenu(currentMenu + '-' + temp);
            }
        } else {
            setCurrentMenu(temp);
        }

        if (window.innerWidth <= 1045) {
            setOpen(false);
        }
    };

    const openCategoryPage = (catType, catName) => {
        setCurrentCategoryType(catType);
        setCurrentCategoryName(catName);
        setCurrentMenu('categoryList');
        if (window.innerWidth <= 1045) {
            setOpen(false);
        }
    };

    const getScreenTitle = (menuStr) => {
        const titles = {
            'home': 'Trang chính', 'trang': 'Trang', 'tintuc': 'Tin tức', 'video': 'Video',
            'audio': 'Audio', 'kinhsach': 'Kinh sách', 'thongbao': 'Thông báo', 'hinhanh': 'Hình ảnh',
            'nhacphatgiao': 'Nhạc Phật Giáo', 'sachnoi': 'Sách nói', 'giangsu': 'Giảng sư',
            'guongsangtuhanh': 'Gương Sáng Tu Hành', 'audiotheobo': 'Audio Theo Bộ',
            'slideshowheader': 'SlideShow Header', 'slideshowhome': 'SlideShow Home',
            'tuydinh': 'Tùy chỉnh', 'menu': 'Menu', 'taikhoan': 'Tài khoản', 'email': 'Email', 'inbox': 'Inbox',
            'loainoidung': 'Loại nội dung', 'thuoctinh': 'Thuộc tính', 'ngonngu': 'Ngôn ngữ', 'quanlytuychinh': 'Quản lý tùy chỉnh',
            'filemanager': 'File Manager', 'profile': 'Thông tin cá nhân', 'choduyet': 'Chờ duyệt'
        };
        let key = menuStr.replace('-create', '').replace('-edit', '');
        return titles[key] || 'Quản trị';
    };

    // Mục menu sidebar có highlight theo màn đang mở
    const menuBase = currentMenu.replace('-create', '').replace('-edit', '');
    const sideItem = (key, label) => (
        <li className={menuBase === key ? 'active' : ''}>
            <a href="#" onClick={e => { e.preventDefault(); clickChangeMenu(key); }}>{label}</a>
        </li>
    );

    return (
        <div className='special-css'>
            <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
            <title>
                {getScreenTitle(currentMenu)} - PixelCMS
            </title>
            <meta name="viewport" content="width=device-width, initial-scale=1.0" />
            <link href="/Areas/Admin/Content/css/css?v=oqHz5ZjriqVjaQGKBfUXqxkz8dHODaJUYBRYo1bpXs01" rel="stylesheet" />
            <link href="/Areas/Admin/Content/plugins/fancybox/jquery.fancybox.css" rel="stylesheet" />
            <style dangerouslySetInnerHTML={{ __html: "\n        #justGaugeExamples {\n            text-align: center;\n            height: 300px;\n        }\n\n        #g1, #g2 {\n            width: 200px;\n            height: 160px;\n            display: inline-block;\n            margin-top: -5px;\n            /*margin: 5px;*/\n        }\n    " }} />
            <style dangerouslySetInnerHTML={{ __html: "\n        .wraper #main {\n            margin-top: 40px;\n        }\n    " }} />
            <div className="wraper sidebar-full">
                <aside className={`social-sidebar dividers sidebar-full 
                    ${open ? 'collapse in' : 'collapse'}
                    `}>
                    <div className="social-sidebar-content">
                        <div className="scrollable" style={{ maxHeight: 'calc(100vh - 60px)', overflowY: 'auto', overflowX: 'hidden' }}>
                            <section className="brand">
                            </section>
                            <section className="menu">
                                <div className="accordion" id="accordion2">
                                    <div id="pixel-dashboard" className="accordion-group">
                                        <div className="accordion-heading">
                                            <a className="accordion-toggle" href="/Admin" style={{ backgroundColor: '#252831' }}>
                                                <img src={require("./Areas/Admin/Content/img/home.png")} alt="Trang chính" />
                                                <span>Trang chính </span>
                                            </a>
                                        </div>
                                    </div>

                                    {/* Chờ duyệt (feature 002): ADMIN + CHECKER */}
                                    {(isAdmin || isChecker) && (
                                        <div id="pixel-choduyet" className="accordion-group">
                                            <div className="accordion-heading">
                                                <a className={`accordion-toggle ${menuBase === 'choduyet' ? 'active' : ''}`} href="#"
                                                    onClick={e => { e.preventDefault(); clickChangeMenu("choduyet"); }}
                                                    style={{ backgroundColor: '#252831' }}>
                                                    <i className="icon-check" style={{ color: 'white', marginRight: '10px', marginLeft: '15px' }} />
                                                    <span>Chờ duyệt </span>
                                                </a>
                                            </div>
                                        </div>
                                    )}

                                    {/* BEGIN MULTI LEVEL ACCORDION GROUP — CMS: ADMIN + MAKER */}
                                    {(isAdmin || isMaker) && (
                                    <div id="pixel-cms" className="accordion-group">
                                        <div className="accordion-heading" style={{ backgroundColor: '#2891cf' }}>
                                            <a
                                                className="accordion-toggle"
                                                href="#collapse-cms"
                                                onClick={(e) => { e.preventDefault(); toggleSubMenu('cms'); }}
                                            >
                                                <img src={require("./Areas/Admin/Content/img/document-library.png")} alt="Trang chính" />
                                                <span>CMS </span>
                                                <span className={`arrow ${openSubMenus.cms ? 'open' : ''}`} style={{ transform: openSubMenus.cms ? 'rotate(90deg)' : 'rotate(0deg)', transition: 'transform 0.3s' }} />
                                            </a>
                                        </div>
                                        {/* Conditionally rendering the 'collapse' class */}
                                        <ul
                                            id="collapse-cms"
                                            className={`accordion-body nav nav-list sub-menu collapse ${openSubMenus.cms ? 'in' : ''}`}
                                            style={{ display: openSubMenus.cms ? 'block' : 'none' }}
                                        >
                                            {sideItem("trang", "Trang")}
                                            {sideItem("tintuc", "Tin tức")}
                                            {sideItem("video", "Video")}
                                            {sideItem("audio", "Audio")}
                                            {sideItem("kinhsach", "Kinh sách")}
                                            {sideItem("thongbao", "Thông báo")}
                                            {sideItem("hinhanh", "Hình ảnh")}
                                            {sideItem("nhacphatgiao", "Nhạc Phật Giáo")}
                                            {sideItem("sachnoi", "Sách nói")}
                                            {sideItem("giangsu", "Giảng sư")}
                                            {sideItem("guongsangtuhanh", "Gương Sáng Tu Hành")}
                                            {sideItem("audiotheobo", "Audio Theo Bộ")}
                                        </ul>
                                    </div>
                                    )}
                                    {isAdmin && (
                                    <div id="pixel-media" className="accordion-group " style={{ backgroundColor: '#2891cf' }}>
                                        {/* BEGIN ACCORDION HEADING */}
                                        <div className="accordion-heading">
                                            <a className="accordion-toggle " href="#collapse-media" onClick={(e) => { e.preventDefault(); toggleSubMenu('media'); }}>
                                                <img src={require("./Areas/Admin/Content/img/photography.png")} alt="Trang chính" />
                                                <span>Media </span>
                                                <span className={`arrow ${openSubMenus.media ? 'open' : ''}`} style={{ transform: openSubMenus.media ? 'rotate(90deg)' : 'rotate(0deg)', transition: 'transform 0.3s' }} />
                                            </a>
                                        </div>
                                        <ul id="collapse-media"
                                            className={`accordion-body nav nav-list collapse ${openSubMenus.media ? 'in' : ''}`}
                                            style={{ display: openSubMenus.media ? 'block' : 'none' }}>
                                            {sideItem("slideshowheader", "SlideShow Header")}
                                            {sideItem("slideshowhome", "SlideShow Home")}
                                        </ul>
                                    </div>
                                    )}


                                    {/* Tuỳ chỉnh ACCORDION — chỉ ADMIN */}
                                    {isAdmin && (
                                    <div id="pixel-tuydinh" className="accordion-group" >
                                        <div className="accordion-heading" style={{ backgroundColor: '#2891cf' }}>
                                            <a className="accordion-toggle" href="#collapse-tuydinh" onClick={(e) => { e.preventDefault(); toggleSubMenu('tuydinh'); }}>
                                                <i className="icon-cogs" style={{ color: 'white', marginRight: '10px', marginLeft: '15px' }} />
                                                <span>Tùy chỉnh </span>
                                                <span className={`arrow ${openSubMenus.tuydinh ? 'open' : ''}`} style={{ transform: openSubMenus.tuydinh ? 'rotate(90deg)' : 'rotate(0deg)', transition: 'transform 0.3s' }} />
                                            </a>
                                        </div>
                                        <ul id="collapse-tuydinh"
                                            className={`accordion-body nav nav-list sub-menu collapse ${openSubMenus.tuydinh ? 'in' : ''}`}
                                            style={{ display: openSubMenus.tuydinh ? 'block' : 'none' }}>
                                            {/* <li><a href="#" onClick={e => { e.preventDefault(); clickChangeMenu("tuydinh"); }}>Tùy chỉnh</a></li> */}
                                            {sideItem("menu", "Menu Header/Footer")}
                                            {sideItem("taikhoan", "Tài khoản")}
                                            {sideItem("email", "Email")}
                                            {/* <li><a href="#" onClick={e => { e.preventDefault(); clickChangeMenu("inbox"); }}>Inbox</a></li> */}
                                        </ul>
                                    </div>
                                    )}
                                    {/* SettingManager ACCORDION */}
                                    <div id="pixel-settingmanager" className="accordion-group" style={{ display: 'none' }}>
                                        <div className="accordion-heading" style={{ backgroundColor: '#2891cf' }}>
                                            <a className="accordion-toggle" href="#collapse-settingmanager" onClick={(e) => { e.preventDefault(); toggleSubMenu('settingmanager'); }}>
                                                <i className="icon-wrench" style={{ color: 'white', marginRight: '10px', marginLeft: '15px' }} />
                                                <span>SettingManager </span>
                                                <span className={`arrow ${openSubMenus.settingmanager ? 'open' : ''}`} style={{ transform: openSubMenus.settingmanager ? 'rotate(90deg)' : 'rotate(0deg)', transition: 'transform 0.3s' }} />
                                            </a>
                                        </div>
                                        <ul id="collapse-settingmanager"
                                            className={`accordion-body nav nav-list collapse ${openSubMenus.settingmanager ? 'in' : ''}`}
                                            style={{ display: openSubMenus.settingmanager ? 'block' : 'none' }}>
                                            <li><a href="#" onClick={e => { e.preventDefault(); clickChangeMenu("loainoidung"); }}>Loại nội dung</a></li>
                                            <li><a href="#" onClick={e => { e.preventDefault(); clickChangeMenu("thuoctinh"); }}>Thuộc tính</a></li>
                                            <li><a href="#" onClick={e => { e.preventDefault(); clickChangeMenu("ngonngu"); }}>Ngôn ngữ</a></li>
                                            <li><a href="#" onClick={e => { e.preventDefault(); clickChangeMenu("quanlytuychinh"); }}>Quản lý tùy chỉnh</a></li>
                                        </ul>
                                    </div>

                                    {/* File Manager BUTTON STYLE (AS IN PRODUCTION - MOVED TO BOTTOM) — chỉ ADMIN */}
                                    {isAdmin && (
                                    <div id="pixel-filemanager" className="accordion-group" style={{ margin: '15px 10px' }}>
                                        <div className="accordion-heading">
                                            <a className="accordion-toggle" href="#" onClick={e => { e.preventDefault(); clickChangeMenu("filemanager"); }}
                                                style={{ backgroundColor: '#5bb75b', borderRadius: '4px', padding: '12px 15px', display: 'flex', alignItems: 'center' }}>
                                                <i className="icon-folder-open" style={{ color: 'white', marginRight: '10px', fontSize: '18px' }} />
                                                <span style={{ color: 'white', fontWeight: 'bold' }}>File manager</span>
                                            </a>
                                        </div>
                                    </div>
                                    )}
                                </div>
                            </section>
                        </div>
                        <div className="chat-users copyright">
                            <a data-toggle="modal" href="#copyright">2013 - 2026 © PixelCMS 6.3</a>
                        </div>
                    </div>

                </aside>
                <header>
                    <nav className={`navbar navbar-fixed-top social-navbar social-sm`}>
                        <div className="navbar-inner">
                            <div className="container-fluid">
                                <a className="btn btn-navbar"
                                    onClick={e => {
                                        e.preventDefault();  // Prevent default anchor behavior
                                        toggleItemMenu("menu");
                                    }}>
                                    <span className="icon-bar" />
                                    <span className="icon-bar" />
                                    <span className="icon-bar" />
                                </a>
                                <ul className="nav pull-right nav-indicators">
                                    {/* Ẩn: ô ngôn ngữ rỗng (chưa dùng) — giữ code để bật lại sau */}
                                    <li style={{ display: 'none' }}>
                                        <div className="language">
                                        </div>
                                    </li>
                                    {/* Ẩn: icon Email trỏ /Admin/Email (route không tồn tại → trang trắng). Quản lý Email dùng menu Tùy chỉnh > Email. */}
                                    <li style={{ display: 'none' }}>    <a href="/Admin/Email">
                                        <div className="email-count-box">
                                            <i className="fa fa-envelope" /><span />
                                        </div>
                                    </a>
                                    {/* Ẩn: dropdown thông báo email (placeholder "0 email", link /Admin/Email không hoạt động) */}
                                    </li><li className="dropdown nav-messages" style={{ display: 'none' }}>
                                        <a href="#" className="dropdown-toggle" data-toggle="dropdown">
                                            <span className="badge">0</span>
                                            <i className="icon-envelope" />
                                        </a>
                                        <ul className="dropdown-menu">
                                            <li className="nav-messages-header">
                                                <a tabIndex={-1} href="#">Bạn có <strong>0</strong> email mới</a>
                                            </li>
                                            <li className="nav-messages-footer">
                                                <a tabIndex={-1} href="/Admin/Email">Xem tất cả email
                                                </a>
                                            </li>
                                        </ul>
                                    </li>
                                    {/* Dropdown người dùng (feature 002): điều khiển bằng React state, không phụ thuộc bootstrap JS */}
                                    <li className={`dropdown user-dropdown ${userMenuOpen ? 'open' : ''}`}>
                                        <a href="#" className="dropdown-toggle" onClick={(e) => { e.preventDefault(); setUserMenuOpen(o => !o); }}>
                                            Xin chào <strong>{userName}</strong>
                                            {role && <span className="role-badge">{role}</span>}
                                            <i className="icon-caret-down" style={{ marginLeft: '6px' }} />
                                        </a>
                                        <ul className="dropdown-menu" style={{ display: userMenuOpen ? 'block' : 'none' }}>
                                            <li>
                                                <a href="#" onClick={(e) => { e.preventDefault(); setUserMenuOpen(false); clickChangeMenu('profile'); }}>
                                                    <i className="icon-user" /> Thông tin cá nhân
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" onClick={(e) => {
                                                    e.preventDefault();
                                                    localStorage.removeItem('token');
                                                    localStorage.removeItem('role');
                                                    localStorage.removeItem('userName');
                                                    window.location.href = '/login';
                                                }}>
                                                    <i className="icon-off" /> Thoát
                                                </a>
                                            </li>
                                        </ul>
                                    </li>
                                    <li>
                                        <a href="/" title="Trang chủ" target="_blank">
                                            {/* <img src="/Areas/Admin/Content/img/icons/stuttgart-icon-pack/16x16/home.png" /> */}
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </nav>
                </header>
                <div id="main">

                    {
                        ((currentMenu.endsWith('create') || currentMenu.endsWith('edit')) && currentMenu !== 'account-create' && currentMenu !== 'taikhoan-roles-edit')
                            // CREATE - UPDATE
                            ? (
                                // TRANG CREATE - UPDATE
                                (currentMenu.startsWith('trang')
                                    && <AdminTrangEditPage currentPostId={currentPostId} clickChangeMenu={clickChangeMenu} postType={10} />)
                                ||
                                // TIN TUC CREATE - UPDATE
                                (currentMenu.startsWith('tintuc')
                                    && <AdminTinTucEditPage currentPostId={currentPostId} clickChangeMenu={clickChangeMenu} postType={16} />)
                                ||
                                // VIDEO CREATE - UPDATE
                                (currentMenu.startsWith('video')
                                    && <AdminVideoEditPage currentPostId={currentPostId} clickChangeMenu={clickChangeMenu} postType={17} />)
                                ||
                                // AUDIO THEO BO CREATE - UPDATE
                                (currentMenu.startsWith('audiotheobo')
                                    && <AdminAudioTheoBoEditPage currentPostId={currentPostId} clickChangeMenu={clickChangeMenu} postType={28} />)
                                ||
                                // AUDIO CREATE - UPDATE
                                (currentMenu.startsWith('audio')
                                    && <AdminAudioEditPage currentPostId={currentPostId} clickChangeMenu={clickChangeMenu} postType={18} />)
                                ||
                                // KINH SACH CREATE - UPDATE
                                (currentMenu.startsWith('kinhsach')
                                    && <AdminKinhSachEditPage currentPostId={currentPostId} clickChangeMenu={clickChangeMenu} postType={19} />)
                                ||
                                // THONG BAO CREATE - UPDATE
                                (currentMenu.startsWith('thongbao')
                                    && <AdminThongBaoEditPage currentPostId={currentPostId} clickChangeMenu={clickChangeMenu} postType={22} />)
                                ||
                                // HINH ANH CREATE - UPDATE
                                (currentMenu.startsWith('hinhanh')
                                    && <AdminHinhAnhEditPage currentPostId={currentPostId} clickChangeMenu={clickChangeMenu} postType={23} />)
                                ||
                                // GIANG SU CREATE - UPDATE
                                (currentMenu.startsWith('giangsu')
                                    && <AdminGiangSuEditPage currentPostId={currentPostId} clickChangeMenu={clickChangeMenu} postType={26} />)
                                ||
                                // GUONG SANG TU HANH CREATE - UPDATE
                                (currentMenu.startsWith('guongsangtuhanh')
                                    && <AdminGuongSangTuHanhEditPage currentPostId={currentPostId} clickChangeMenu={clickChangeMenu} postType={27} />)
                                ||
                                // NHAC PHAT GIAO CREATE - UPDATE
                                (currentMenu.startsWith('nhacphatgiao')
                                    && <AdminNhacPhatGiaoEditPage currentPostId={currentPostId} clickChangeMenu={clickChangeMenu} postType={24} />)
                                ||
                                // SACH NOI CREATE - UPDATE
                                (currentMenu.startsWith('sachnoi')
                                    && <AdminSachNoiEditPage currentPostId={currentPostId} clickChangeMenu={clickChangeMenu} postType={25} />)
                                ||
                                // SLIDESHOW HEADER CREATE - UPDATE
                                (currentMenu.startsWith('slideshowheader')
                                    && <AdminSlideShowHeaderEditPage currentPostId={currentPostId} clickChangeMenu={clickChangeMenu} />)
                                ||
                                // SLIDESHOW HOME CREATE - UPDATE
                                (currentMenu.startsWith('slideshowhome')
                                    && <AdminSlideShowHomeEditPage currentPostId={currentPostId} clickChangeMenu={clickChangeMenu} />)
                                ||
                                // CATEGORY CREATE - UPDATE
                                (currentMenu.startsWith('categoryList')
                                    && <AdminCategoryEditPage currentCategoryId={currentPostId} currentCategoryType={currentCategoryType} currentCategoryName={currentCategoryName} clickChangeMenu={clickChangeMenu} />)
                            ) :
                            // LIST
                            <div className="container-fluid">
                                <div className="row-fluid">
                                    <div className="span12"
                                        style={{
                                            backgroundColor: 'white',
                                            paddingLeft: '10px',
                                            paddingRight: '10px'
                                        }}>
                                        {
                                            currentMenu == 'home' &&
                                            <AdminHomePage clickChangeMenu={clickChangeMenu} />
                                        }

                                        {/* TIN TUC PAGE */}
                                        {
                                            (currentMenu == 'trang'
                                                || currentMenu == 'tintuc'
                                                || currentMenu == 'video'
                                                || currentMenu == 'audio'
                                                || currentMenu == 'kinhsach'
                                                || currentMenu == 'thongbao'
                                                || currentMenu == 'hinhanh'
                                                || currentMenu == 'giangsu'
                                                || currentMenu == 'guongsangtuhanh'
                                                || currentMenu == 'audiotheobo'
                                                || currentMenu == 'slideshowheader'
                                                || currentMenu == 'slideshowhome'
                                            ) &&
                                            <AdminTintucPage
                                                currentMenu={currentMenu}
                                                clickChangeMenu={clickChangeMenu}
                                                changeCurrentPostId={changeCurrentPostId}
                                                openCategoryPage={openCategoryPage}
                                            />
                                        }

                                        {/* NHAC PHAT GIAO PAGE */}
                                        {
                                            currentMenu == 'nhacphatgiao' &&
                                            <AdminNhacPhatGiaoPage
                                                clickChangeMenu={clickChangeMenu}
                                                changeCurrentPostId={changeCurrentPostId}
                                                openCategoryPage={openCategoryPage}
                                            />
                                        }

                                        {/* SACH NOI PAGE */}
                                        {
                                            currentMenu == 'sachnoi' &&
                                            <AdminSachNoiPage
                                                clickChangeMenu={clickChangeMenu}
                                                changeCurrentPostId={changeCurrentPostId}
                                                openCategoryPage={openCategoryPage}
                                            />
                                        }

                                        {/* CATEGORY LIST PAGE */}
                                        {
                                            currentMenu === 'categoryList' &&
                                            <AdminCategoryPage
                                                postType={currentCategoryType}
                                                pageTitle={currentCategoryName}
                                                clickChangeMenu={clickChangeMenu}
                                                changeCurrentPostId={changeCurrentPostId}
                                            />
                                        }

                                        {/* SYSTEM SETTINGS */}
                                        {/* SYSTEM SETTINGS (CATEGORIZED FORM) */}
                                        {currentMenu == 'tuydinh' && <AdminGeneralSettingPage clickChangeMenu={clickChangeMenu} />}

                                        {/* MENU MANAGEMENT */}
                                        {currentMenu == 'menu' && <AdminMenuPage clickChangeMenu={clickChangeMenu} />}

                                        {/* ACCOUNT MANAGEMENT */}
                                        {currentMenu == 'taikhoan' && <AdminAccountPage clickChangeMenu={clickChangeMenu} />}
                                        {currentMenu == 'taikhoan-roles' && <AdminRolePage clickChangeMenu={clickChangeMenu} setEditingRole={setEditingRole} />}
                                        {currentMenu == 'taikhoan-roles-edit' && <AdminRoleEditPage clickChangeMenu={clickChangeMenu} editingRole={editingRole} />}
                                        {currentMenu == 'taikhoan-roles-permissions' && <AdminRolePermissionEditPage clickChangeMenu={clickChangeMenu} editingRole={editingRole} />}
                                        {currentMenu == 'account-create' && <AdminAccountEditPage clickChangeMenu={clickChangeMenu} />}

                                        {/* LOAI NOI DUNG */}
                                        {currentMenu === 'loainoidung' && <AdminPosttypePage clickChangeMenu={clickChangeMenu} />}

                                        {/* THUOC TINH */}
                                        {currentMenu === 'thuoctinh' && <AdminAttributePage clickChangeMenu={clickChangeMenu} />}

                                        {/* NGON NGU */}
                                        {currentMenu === 'ngonngu' && <AdminLanguagePage clickChangeMenu={clickChangeMenu} />}

                                        {/* QUAN LY TUY CHINH (TABLE) */}
                                        {currentMenu === 'quanlytuychinh' && <AdminSettingPage clickChangeMenu={clickChangeMenu} />}


                                        {/* EMAIL & INBOX PAGES */}
                                        {
                                            (currentMenu == 'email' || currentMenu == 'inbox') &&
                                            <AdminEmailPage clickChangeMenu={clickChangeMenu} />
                                        }

                                        {/* PROFILE & PENDING (feature 002) */}
                                        {currentMenu == 'profile' && <AdminProfilePage />}
                                        {currentMenu == 'choduyet' && <AdminPendingPage />}

                                        {/* FILE MANAGER PAGE */}
                                        {currentMenu == 'filemanager' && <AdminFileManagerPage clickChangeMenu={clickChangeMenu} />}

                                    </div>
                                </div>
                            </div>
                    }
                </div>
            </div>
        </div>
    );
}
export default AdminPage;
